import URL from '../url'
import Request from '../request'
import axios from 'axios'

/**
 *
 * @param {*} query
 */
export const courseListService = query =>
  new Request(URL.API, URL.COURSE_LIST).post(query)

/**
 *
 * @param {*} id
 */
export const courseGetService = id =>
  new Request(URL.API, URL.GET_COURSE.replace('{id}', id)).get()

/**
 *
 * @param {*} entity
 */
export const courseAddService = entity =>
  new Request(URL.API, URL.ADD_COURSE).post(entity)

/**
 *
 * @param {*} entity
 */
export const courseEditService = entity =>
  new Request(URL.API, URL.EDIT_COURSE).put(entity)

/**
 *
 * @param {*} id
 */
export const courseDeleteService = id =>
  new Request(URL.API, URL.DELETE_COURSE).delete({ id })

/**
 *
 * @param {*} content
 */
export const coursePatchService = content =>
  new Request(URL.API, URL.PATCH_COURSE + '?id=' + content.id).patch(content)

/**
 *
 * @param {*} id
 */
export const courseCloneService = code =>
  new Request(URL.API, URL.CLONE_COURSE).post({ code })

/**
 * @param {*} id
 *
 */
export const courseSettingPatchService = content => {
  new Request(URL.API, URL.PATCH_COURSE_SETTING + '?id=' + content.id).patch(
    content.data,
  )
}

/**
 * @param {*} id
 *
 */
export const courseSettingCreateService = content =>
  new Request(URL.API, URL.CREATE_COURSE_SETTING).post(content)

/**
 *
 * @param {*} starterText
 * @param {*} courseId
 * @param {*} cardId
 */

export const openaiSendCardRequestService = (starterText, courseId, cardId) =>
  new Request(URL.API, URL.OPENAI_SEND_CARD_REQUEST).post({
    starterText,
    courseId,
    cardId,
  })

/**
 *
 * @param {*} starterText
 */

export const aiInstructionRequestService = (starterText, language) =>
  new Request('https://claude-ghwy.onrender.com', '/api/suggestions').post({
    source_text: starterText,
    language: language,
  })

/**

/**
 *
 * @param {*} profession
 * @param {*} audience
 * @param {*} description
 * @param {*} language
 * @param {*} purpose
 */
export const openaiSendCourseCreationGetTitleRequestService = (
  profession,
  audience,
  description,
  language,
  purpose,
) =>
  new Request(URL.API, URL.OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST).post({
    profession,
    audience,
    description,
    language,
    purpose,
  })

/**
 *
 * @param {*} profession,
 * @param {*} audience,
 * @param {*}title,
 * @param {*}language,
 * @param {*}purpose,
 */
export const openaiSendCourseCreationGetOutlineRequestService = (
  profession,
  audience,
  title,
  language,
  purpose,
) =>
  new Request(
    URL.API,
    URL.OPENAI_SEND_COURSE_CREATION_GET_OUTLINE_REQUEST,
  ).post({
    profession,
    audience,
    title,
    language,
    purpose,
  })

/**
 * @param {*}firstCardText
 * @param {*} profession
 * @param {*} title
 * @param {*} outlines
 * @param {*} audience
 * @param {*} description
 * @param {*} courseCollectionId
 * @param {*} language
 * @param {*} purpose
 * @param {*} selectedPreset
 */
export const openaiSendCourseCreationRequestService = (
  title,
  outlines,
  profession,
  audience,
  description,
  themeSettings,
  courseCollectionId,
  variables,
  gatewaySelection,
  language,
  purpose,
  imageGenerator,
  generateImage,
) =>
  new Request(URL.API, URL.OPENAI_SEND_COURSE_CREATION_REQUEST).post({
    title,
    outlines,
    profession,
    audience,
    description,
    themeSettings,
    courseCollectionId,
    variables,
    gatewaySelection,
    language,
    purpose,
    imageGenerator,
    generateImage,
  })

/**
 *
 * @param {*} code
 * @param {*} title
 * @param {*} collectionId
 */
export const coursetCloneTemplateCourseService = (code, title, collectionId) =>
  new Request(URL.API, URL.CLONE_TEMPLATE_COURSE).post({
    code,
    title,
    collectionId,
  })

/**
 *
 * @param {*} starterText
 */

export const sendCreatePromptFromCardContentRequestService = starterText =>
  new Request(URL.API, URL.CREATE_PROMPT_FROM_CARD).post({
    starterText,
  })

/**
 *
 * @param {*} courseId
 */

export const getCourseAnalyticsByIdService = courseId => {
  return new Request(URL.API, URL.GET_COURSE_ANALYTICS).post({
    courseId,
  })
}

/**
 *
 *
 */

export const createSectionWithCardIdsService = (courseId, name, cardIds) =>
  new Request(URL.API, URL.CREATE_SECTION_WITH_CARD_IDS).post({
    courseId,
    name,
    cardIds,
  })

/**
 *
 * @param {*} content
 */
export const sectionPatchService = content =>
  new Request(URL.API, URL.PATCH_SECTION + '?id=' + content.id).patch(content)

/**
 *
 * @param {*} courseId
 */
export const generateQuizzesByCourseIdService = courseId =>
  new Request(URL.API, URL.GET_QUIZZES_BY_COURSE_ID).post({ courseId })

/**
 *
 * @param {*} id
 */
export const courseCreationProgressService = id =>
  new Request(
    URL.API,
    URL.GET_COURSE_CREATION_PROGRESS.replace('{id}', id),
  ).get()

/**
 *
 * @param {*} id
 * @param {*} scormVersion
 */
export const exportCourseToScormService = (id, scormVersion) =>
  new Request(URL.API, URL.EXPORT_COURSE_TO_SCORM.replace('{id}', id)).post(
    {
      scormVersion: scormVersion,
    },
    {
      responseType: 'blob',
    },
  )

/**
 * @param {*} id
 * @param {*} sections
 */

export const editSectionOrderService = (id, sections) =>
  new Request(URL.API, URL.EDIT_SECTION_ORDER.replace('{id}', id)).put(sections)

export const addSectionService = data =>
  new Request(URL.API, URL.ADD_SECTION).post(data)

export const createCourseService = data =>
  new Request(URL.API, URL.CREATE_COURSE).post(data)

export const courseGetAssignmentService = id =>
  new Request(URL.API, URL.GET_ASSIGNMENT).get({ id })

export const generateCardService = data =>
  new Request(URL.API, URL.GENERATE_CARD).post(data)

export const getCourseLandingPageService = id =>
  new Request(URL.API, URL.GET_COURSE_LANDING_PAGE.replace('{id}', id)).get()

export const landingPagePatchService = (id, data) =>
  new Request(URL.API, URL.PATCH_COURSE_LANDING_PAGE.replace('{id}', id)).patch(
    data,
  )

export const courseFilterService = data =>
  new Request(URL.API, URL.COURSE_FILTER).post(data)
